import { FC } from 'react';
import { Trans } from 'react-i18next';
import { LoginToggleMenuProps } from './loginToggleMenu.type';
import { LoginToggleKey } from '../../utils/helper.type';
import './loginToggleMenu.css';

const LoginToggleMenu: FC<LoginToggleMenuProps> = (props) => {
  return (
    <div className="w-full flex">
      {/* Tablet view */}
      <div className="tablet-container">
        {[LoginToggleKey.STAFF, LoginToggleKey.ADMIN].map(
          (key: LoginToggleKey) => (
            <button
              key={key}
              className={`tablet-button ${
                props.active === key
                  ? 'tablet-active-button'
                  : 'bg-transparent text-white'
              }`}
              onClick={() => props.onToggle(key)}
              data-testid={`login-toggle-${key.toLowerCase()}-tablet`}
            >
              <Trans i18nKey={`login.loginToggle.${key.toLowerCase()}`} />
            </button>
          ),
        )}
      </div>

      {/* Desktop view */}
      <div className="hidden lg:flex items-center">
        {[LoginToggleKey.STAFF, LoginToggleKey.ADMIN].map(
          (key: LoginToggleKey) => (
            <button
              key={key}
              className={`toggle-button-spacing ${
                props.active === key
                  ? 'login-toggle-active'
                  : 'login-toggle-inactive'
              }`}
              onClick={() => props.onToggle(key)}
              data-testid={`login-toggle-${key.toLowerCase()}-desktop`}
            >
              <Trans i18nKey={`login.loginToggle.${key.toLowerCase()}`} />
            </button>
          ),
        )}
      </div>
    </div>
  );
};

export default LoginToggleMenu;
